var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-page"},[_c('Header'),_c('SmoothScroll',[_c('WhatIsJujuna'),_c('JujunaBottle'),_c('JujunaPacks'),_c('DraughtJujuna'),_c('StickerBar',{attrs:{"bgColor":'#BACB32'}}),_c('MobileBar'),_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }